var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11645_4215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11645_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3 3.1C9.59186 1.90182 10.863 1 12.387 1C13.9109 1 15.1821 1.90182 15.474 3.1H19.9C21.0046 3.1 21.9 3.99543 21.9 5.1V20C21.9 21.1046 21.0046 22 19.9 22H5C3.89543 22 3 21.1046 3 20V5.1C3 3.99543 3.89543 3.1 5 3.1H9.3ZM19.9 5.1L5 5.1L5 20L19.9 20L19.9 5.1ZM12.45 4.15C13.0299 4.15 13.5 3.6799 13.5 3.1C13.5 2.5201 13.0299 2.05 12.45 2.05C11.8701 2.05 11.4 2.5201 11.4 3.1C11.4 3.6799 11.8701 4.15 12.45 4.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05762 8.25015C8.50976 7.74683 9.28432 7.70534 9.78764 8.15748L12.5627 10.6504L15.3378 8.15748C15.8411 7.70534 16.6156 7.74683 17.0678 8.25015C17.5199 8.75347 17.4784 9.52802 16.9751 9.98016L14.3959 12.2971L16.9749 14.6139C17.4782 15.066 17.5197 15.8406 17.0676 16.3439C16.6154 16.8472 15.8409 16.8887 15.3375 16.4366L12.5627 13.9439L9.78786 16.4366C9.28454 16.8887 8.50999 16.8472 8.05785 16.3439C7.60571 15.8406 7.6472 15.066 8.15052 14.6139L10.7295 12.2971L8.15029 9.98016C7.64697 9.52802 7.60548 8.75347 8.05762 8.25015Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmark);
export default __webpack_public_path__ + "static/media/unmark.7b1055b898138d6290348024c2767241.svg";
export { ForwardRef as ReactComponent };